import { jsx as _jsx } from "react/jsx-runtime";
// copied from: https://github.com/kadirahq/react-no-ssr
import { useEffect, useState } from 'react';

var DefaultOnSSR = function DefaultOnSSR() {
  return /*#__PURE__*/_jsx("span", {});
};

export default function NoSSR(_ref) {
  var children = _ref.children,
      _ref$onSSR = _ref.onSSR,
      onSSR = _ref$onSSR === void 0 ? /*#__PURE__*/_jsx(DefaultOnSSR, {}) : _ref$onSSR;

  var _useState = useState(false),
      canRender = _useState[0],
      setCanRender = _useState[1];

  useEffect(function () {
    setCanRender(true);
  }, []);
  return canRender ? children : onSSR;
}